export function formDataFromObject(object) {
  const formData = new FormData();
  Object.entries(object).forEach(([k, v]) => {
    formData.append(k, v.toString());
  });
  return formData;
}
